export default __webpack_public_path__ + "static/media/about-part-1.85872358.jpg";